import React from 'react'
import { MenuProps, Menu } from '@mui/material'
import styled from 'styled-components'

export interface PopoverProps extends MenuProps {
  customPaperStyle?: React.CSSProperties
}

export const Popover = styled((props: PopoverProps) => (
  <Menu
    elevation={0}
    autoFocus={false}
    disableAutoFocusItem
    disableAutoFocus
    disableEnforceFocus
    disableRestoreFocus
    {...props}
  />
))(
  ({ theme, customPaperStyle }) => ({
    '& .MuiPaper-root': {
      backgroundColor: theme.colors.black,
      borderRadius: '8px',
      '::before': {
        display: 'none'
      },
      ...customPaperStyle
    },
    '& .MuiList-root': {
      padding: 0
    },
    '& .MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper:before': {
      display: 'none'
    }
  })
)
